import React from 'react'

import {
  DeliveryForecast,
  PatchRequest,
  WebEdiDeliveryForecastDto,
} from '../../../../data/models'
import { useConfigContext } from '../../../ui-config'
import {
  DataForConfirmationDto,
  DataForConfirmationPatchDto,
  requestPatchDeliveryForecastsById,
  useDeliveryForecastById,
} from '../../data'
import { DataForConfirmationForm } from './DataForConfirmation.form'

type Props = {
  deliveryForecastId: string
}

export const DataForConfirmationData: React.FC<Props> = ({
  deliveryForecastId,
}) => {
  const { uiConfig: config } = useConfigContext()
  const { data, isLoading, mutate } =
    useDeliveryForecastById(deliveryForecastId)

  const dataToFormValues = (
    data: WebEdiDeliveryForecastDto<DeliveryForecast> | undefined,
  ): DataForConfirmationDto => {
    return {
      responsePeriod: data?.Payload.ResponsePeriod,
      confirmationId: data?.Payload.ConfirmationId || '',
      department: data?.Payload.Department || '',
      contactName: data?.Payload.ContactName || '',
      contactPhone: data?.Payload.ContactPhone || '',
      contactMail: data?.Payload.ContactMail || '',
    }
  }

  const patchFromFormValues = (
    formData: DataForConfirmationDto,
  ): PatchRequest<WebEdiDeliveryForecastDto<DeliveryForecast>> => {
    const patchOperations: PatchRequest<
      WebEdiDeliveryForecastDto<DeliveryForecast>
    > = []

    // confirmationId
    if (formData.confirmationId !== data?.Payload.ConfirmationId) {
      patchOperations.push({
        op: data?.Payload.ConfirmationId ? 'replace' : 'add',
        path: '/Payload/ConfirmationId',
        value: formData.confirmationId,
      })
    }

    // department
    if (formData.department !== data?.Payload.Department) {
      patchOperations.push({
        op: data?.Payload.Department ? 'replace' : 'add',
        path: '/Payload/Department',
        value: formData.department,
      })
    }

    // contactName
    if (formData.contactName !== data?.Payload.ContactName) {
      patchOperations.push({
        op: data?.Payload.ContactName ? 'replace' : 'add',
        path: '/Payload/ContactName',
        value: formData.contactName,
      })
    }

    // contactPhone
    if (formData.contactPhone !== data?.Payload.ContactPhone) {
      patchOperations.push({
        op: data?.Payload.ContactPhone ? 'replace' : 'add',
        path: '/Payload/ContactPhone',
        value: formData.contactPhone,
      })
    }

    // contactMail
    if (formData.contactMail !== data?.Payload.ContactMail) {
      patchOperations.push({
        op: data?.Payload.ContactMail ? 'replace' : 'add',
        path: '/Payload/ContactMail',
        value: formData.contactMail,
      })
    }

    return patchOperations
  }

  const onFormSubmit = async (formData: DataForConfirmationPatchDto) => {
    const patchData: PatchRequest<WebEdiDeliveryForecastDto> =
      patchFromFormValues(formData)
    await requestPatchDeliveryForecastsById(deliveryForecastId, patchData)
    mutate()
  }

  return (
    <DataForConfirmationForm
      data={dataToFormValues(data)}
      config={config}
      onSubmit={onFormSubmit}
      isLoading={isLoading}
    />
  )
}
